export default "__VITE_ASSET__D9jNJyYJ__"